module.exports = __webpack_public_path__ + "img/scarf.be5030ca.webp";